import { render, staticRenderFns } from "./AamsLicenseRegEstateInfo.vue?vue&type=template&id=606dfe17&scoped=true&"
import script from "./AamsLicenseRegEstateInfo.vue?vue&type=script&lang=js&"
export * from "./AamsLicenseRegEstateInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606dfe17",
  null
  
)

export default component.exports